import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "../components/Navbar_Footer/Navbar/NavBar";
import { Banner } from "../components/Banner/Banner";
import { Skills } from "../components/Skills/Skills";
import { Tools } from "../components/Tools/Tools";
import { Certifications } from "../components/About_Certs/Certifications/Certifications";
import { Projects } from "../components/Projects/Projects";
import { AboutMe } from "../components/About_Certs/AboutMe/AboutMe";
import { Contact } from "../components/Contact/Contact";
import { Footer } from "../components/Navbar_Footer/Footer/Footer";
function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Tools />
      <Certifications />
      <Projects />
      <AboutMe />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
